import React from "react"
import { Formik, Form as FormikForm, Field } from "formik"
import { Row, Col, Form } from "react-bootstrap"
import * as Yup from "yup"
import * as Constants from "../../../common/constants"
import FormTextbox from "../WindscreenClaim/components/formTextbox"
import FormFieldDisableAutoComplete from "../WindscreenClaim/components/formFieldDisableAutoComplete"
import FormMobileTextBox from "../WindscreenClaim/components/formMobileTextBox"
import FormDropdownArray from "../WindscreenClaim/components/formDropdownArray"
import FormLabel from "../../shared/formLabel"
import FormEditUpload from "../WindscreenClaim/components/formEditUpload"

const ReviewClaim = React.memo(props => {
  const { claimData, uiData } = props
  const { pageNumber, workshopList } = uiData

  const category = "claimInfo"
  const details = "policyInfo"
  const formName = "Review Policy Information"

  const formClickedNext = true

  const policyInfoSchema = Yup.object().shape({
    workshop: Yup.string().required(Constants.workshopErrorMsg),
    otherWorkshopName: Yup.string().when("workshop", {
      is: value => value === "Others",
      then: Yup.string().required(Constants.workshopNameErrorMsg),
    }),
    otherWorkshopContactNo: Yup.string().when("workshop", {
      is: value => value === "Others",
      then: Yup.string().required(Constants.workshopContactNoErrorMsg),
    }),
    otherWorkshopAddress: Yup.string().when("workshop", {
      is: value => value === "Others",
      then: Yup.string().required(Constants.workshopAddressErrorMsg),
    }),
    workshopContactPerson: Yup.string()
      .required(Constants.workshopContactPersonErrorMsg)
      .matches(Constants.namepattern, Constants.workshopContactPersonErrorMsg),
    workshopEmail: Yup.string()
      .required(Constants.workshopEmailErrorMsg)
      .email(Constants.workshopEmailErrorMsg),

    vehicleNumber: Yup.string().required(Constants.vehicleNumberErrorMsg),
    //.matches(Constants.namepattern, Constants.vehicleNumberErrorMsgErrorMsg),

    claimantNricNumber: Yup.string()
      //.required(Constants.claimantNricErrorMsg)
      .matches(Constants.nricpattern, Constants.claimantNricErrorMsg),
    claimantEmail: Yup.string()
      //.required(Constants.claimantEmailErrorMsg)
      .email(Constants.claimantEmailErrorMsg),
    claimantMobile: Yup.string()
      //.required(Constants.claimantMobileErrorMsg)
      // .length(8, Constants.mobileErrorMsg)
      .matches(Constants.mobilepattern, Constants.claimantMobileErrorMsg),
  })

  return (
    <Row className={pageNumber === 5 ? "" : "hide"}>
      <div
        className={
          "title text-center MarginTop75 " + (pageNumber === 5 ? "" : "hide")
        }
      >
        Review and modify the claim information
      </div>
      <div className="marginTop1x borderBottomDottedGrey noPaddingLeftRightSmallScreen mb-4 bigScreenNarrowing width100">
        <div className="col-12 benefitsHeaderSummaryDiv">
          Claimant Information
        </div>
      </div>
      <Row className="col-xs-12 containerBody summaryContainerBody mb-4 blueBG">
        <Formik
          initialValues={claimData[category][details]}
          enableReinitialize={true}
          validationSchema={policyInfoSchema}
          validateOnMount={true}
        >
          {({ handleSubmit, isValid, values }) => (
            <FormikForm
              id="summary"
              onSubmit={handleSubmit}
              className="formContainer col-xs-12 col-md-12"
            >
              {" "}
              <Form.Group>
                <Row className="form-group">
                  <div className="col-12 textforinput marginTop10px benefitEditTitle">
                    <p>Please review the claimant information</p>
                  </div>
                </Row>
              </Form.Group>
              {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
              <Field
                textDesc={"Disable Auto Complete"}
                name="disableAutoComplete"
                component={FormFieldDisableAutoComplete}
              />
              <Field
                textDesc={"Workshop"}
                coverageCategory={category}
                coverageCode={details}
                name="workshop"
                component={FormDropdownArray}
                propertyName={"Workshop"}
                dropdownItem={workshopList}
                formIsValid={isValid}
                formName={formName}
                clickedNext={formClickedNext}
                extraFieldValue={["Others"]}
                affectedField={[
                  "otherWorkshopName",
                  "otherWorkshopContactNo",
                  "otherWorkshopAddress",
                ]}
              />
              {values.workshop && values.workshop === "Others" && (
                <>
                  {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc={"Name of Workshop"}
                    coverageCategory={category}
                    coverageCode={details}
                    maxLength={200}
                    name="otherWorkshopName"
                    component={FormTextbox}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                    toUpperCase={false}
                  />
                  <Field
                    textDesc={"Contact Number"}
                    coverageCategory={category}
                    coverageCode={details}
                    maxLength={9}
                    name="otherWorkshopContactNo"
                    component={FormMobileTextBox}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                  />
                  <Field
                    textDesc={"Address of Workshop"}
                    coverageCategory={category}
                    coverageCode={details}
                    maxLength={200}
                    name="otherWorkshopAddress"
                    component={FormTextbox}
                    formIsValid={isValid}
                    formName={formName}
                    clickedNext={formClickedNext}
                    toUpperCase={false}
                  />
                </>
              )}
              <Field
                textDesc={"Contact Person"}
                coverageCategory={category}
                coverageCode={details}
                maxLength={50}
                name="workshopContactPerson"
                component={FormTextbox}
                formIsValid={isValid}
                formName={formName}
                clickedNext={formClickedNext}
                toUpperCase={true}
              />
              <Field
                textDesc={"Workshop Email"}
                coverageCategory={category}
                coverageCode={details}
                maxLength={100}
                name="workshopEmail"
                component={FormTextbox}
                formIsValid={isValid}
                clickedNext={formClickedNext}
                toUpperCase={false}
              />
              <Form.Group>
                <Row>
                  <FormLabel text="Policy Number" />
                  <Col xs={12} md={6} className="marginTop10px">
                    <Field
                      name="policyNumber"
                      className="inputbox"
                      type="text"
                      value={values.policyNumber ? values.policyNumber : ""}
                      readOnly="readOnly"
                    />
                  </Col>
                </Row>
              </Form.Group>
              <Field
                textDesc={"Vehicle Number"}
                coverageCategory={category}
                coverageCode={details}
                maxLength={20}
                name="vehicleNumber"
                component={FormTextbox}
                formIsValid={isValid}
                formName={formName}
                clickedNext={formClickedNext}
                toUpperCase={true}
              />
              <Form.Group>
                <Row>
                  <FormLabel text="Name of Insured as per policy schedule" />
                  <Col xs={12} md={6} className="marginTop10px">
                    <Field
                      name="policyHolderName"
                      className="inputbox"
                      type="text"
                      value={
                        values.policyHolderName ? values.policyHolderName : ""
                      }
                      readOnly="readOnly"
                    />
                  </Col>
                </Row>
              </Form.Group>
              <Field
                textDesc={"Policyholder's NRIC/PP No"}
                coverageCategory={category}
                coverageCode={details}
                maxLength={10}
                name="claimantNricNumber"
                component={FormTextbox}
                formIsValid={isValid}
                formName={formName}
                clickedNext={formClickedNext}
                toUpperCase={true}
              />
              <Field
                textDesc={"Policyholder's Email"}
                coverageCategory={category}
                coverageCode={details}
                maxLength={100}
                name="claimantEmail"
                component={FormTextbox}
                formIsValid={isValid}
                clickedNext={formClickedNext}
                toUpperCase={false}
              />
              <Field
                textDesc={"Policyholder's Mobile Number"}
                coverageCategory={category}
                coverageCode={details}
                maxLength={9}
                name="claimantMobile"
                component={FormMobileTextBox}
                formIsValid={isValid}
                clickedNext={formClickedNext}
              />
              {
                <FormEditUpload
                  editBenefits={true}
                  allProofDocuments={uiData.proofDocuments}
                  claimUploadListModel={uiData.claimUploadListModel}
                />
              }
            </FormikForm>
          )}
        </Formik>
      </Row>
    </Row>
  )
})
export default ReviewClaim
